import { css } from 'styled-components'

// utils
const grid = breakpoint => {
  let gridStyles = ''
  if (breakpoint) {
    for (let i = 1; i <= 12; i++) {
      const unit = 1 / 12
      const w = unit * i * 100
      gridStyles += `.col-${breakpoint}-${i} {width: ${w}%}`
    }
  } else {
    for (let i = 1; i <= 12; i++) {
      const unit = 1 / 12
      const w = unit * i * 100
      gridStyles += `.col-${i} {width: ${w}%}`
    }
  }

  return css`
    ${gridStyles}
  `
}

const display = (breakpoint, display) =>
  css`
    .d-${breakpoint}-${display} {
      display: ${display};
    }
  `

const container = width =>
  css`
    .container {
      width: ${width};
    }
  `

export { grid, display, container }
